import React from 'react';
import { AnimatedCounter } from './AnimatedCounter';

export const StatsCards = ({ stats, formatCurrency }) => {

  const cards = [
    {
      title: 'Total Events',
      value: stats.TotalEvents || 0,
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      ),
      color: 'blue'
    },
    {
      title: 'Total Paid Amount',
      value: formatCurrency(stats.TotalSuccessAmount || 0),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: 'green'
    },
    {
      title: 'Pending Amount',
      value: formatCurrency(stats.PendingAmount || 0),
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: 'orange'
    },
    {
      title: 'Total Registered',
      value: <AnimatedCounter value={stats.TotalSuccessfulRegistrations || 0} />,
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13.5 0h-6m6 0V9a3 3 0 00-3-3h-1.5m6 0c0-1.657-1.343-3-3-3m-9 0c0 1.657 1.343 3 3 3m0 0h1.5M9 3C7.343 3 6 4.343 6 6m0 0v1.5M6 9c0 1.657 1.343 3 3 3m0 0h1.5" />
        </svg>
      ),
      color: 'purple'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`bg-gradient-to-br from-white to-${card.color}-50 rounded-2xl p-6 shadow-xl border border-${card.color}-100 relative overflow-hidden group hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1`}
        >
          <div className={`absolute -right-4 -top-4 w-20 h-20 bg-${card.color}-500 opacity-5 rounded-full group-hover:scale-150 transition-transform duration-500`}></div>
          <div className="flex items-center gap-4">
            <div className={`w-12 h-12 rounded-xl bg-${card.color}-100 flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
              <div className={`text-${card.color}-600`}>{card.icon}</div>
            </div>
            <div>
              <div className={`text-2xl font-bold text-${card.color}-600`}>{card.value}</div>
              <div className="text-sm text-gray-600 font-medium">{card.title}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};